//
// Module for voucher detail
//
rs.module("content/employer/reporting/vouchers/detail",

    ["controls/data/grid", "common/visibility"],

    function (gridModule, visibility) {

        // Initialize the module
        function initialize(voucherDetailsGridLrsApi, jsSelectors, ajaxUrls) {

            var employerVoucherEdit = $.js(jsSelectors.employerVoucherEdit);

            var voucherNumberTableCell = employerVoucherEdit.js(jsSelectors.voucherNumberTableCell);

            var saveVoucherButton = employerVoucherEdit.js(jsSelectors.saveVoucherButton, { required: false });
            var submitVoucherButton = employerVoucherEdit.js(jsSelectors.submitVoucherButton, { required: false });

            var voucherDetailsForm = employerVoucherEdit.js(jsSelectors.voucherDetailsForm);

            var voucherKeyInput = voucherDetailsForm.js(jsSelectors.voucherKeyInput);
            var addDetailLink = voucherDetailsForm.js(jsSelectors.addDetailLink);
            var loadFromBatchDetailLink = voucherDetailsForm.js(jsSelectors.loadFromBatchDetailLink, { required: false });

            // add grid row for inline editing
            addDetailLink.on("click", function () {
                voucherDetailsGridLrsApi.addRow();

                // The moment a new row is added, disable the voucher save. It'll be reset once the row is resolved.
                if (saveVoucherButton) {
                    saveVoucherButton.setDisabled(true);
                }
                if (submitVoucherButton) {
                    submitVoucherButton.setDisabled(true);
                }
            });

            if (loadFromBatchDetailLink) {
                // pre-poplulate grid rows for inline editing
                loadFromBatchDetailLink.on("click", function () {

                    gridModule.update(
                        ajaxUrls.loadFromBatchDetail,
                        { voucherKey: voucherKeyInput.val(), voucherNumber: voucherNumberTableCell.html() },
                        voucherDetailsGridLrsApi.agGridApi,
                        function done(gridUpdate) { },
                        { appendAsPending: true }
                    );

                });
            }

            // If row data has changed, 
            // evaluate for actions to take
            voucherDetailsGridLrsApi.rowChanged(function (change) {
                EvaluatePendingRows();
            });

            // Based if there exists inline edited rows, 
            // toggle voucher buttons and loadFromBatchDetailLink
            function EvaluatePendingRows() {

                var rowsDisplayed = voucherDetailsGridLrsApi.getChanges().length > 0;

                if (saveVoucherButton) {
                    saveVoucherButton.setDisabled(rowsDisplayed);
                }

                if (submitVoucherButton) {
                    submitVoucherButton.setDisabled(rowsDisplayed);
                }

                if (loadFromBatchDetailLink) {
                    visibility.setVisible(loadFromBatchDetailLink, !rowsDisplayed);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);